import styled from "styled-components/macro";
import { entityImageStyles } from "../EntityImage/styles";

export const Container = styled.div`
  .hidden {
    display: none;
  }
  .character-card {
    background-color: var(--simplified-sb-background);
    border-radius: 20px;
    box-shadow: var(--tiny-drop-shadow-head-on);
    margin-bottom: 10px;
    position: relative;
    padding: 10px 14px;
    margin: 0px 16px;
  }

  .collapsed-entity {
    .header {
      margin-bottom: 0px;
    }
  }

  .selected-entity {
    box-sizing: border-box;
    background: linear-gradient(0deg, var(--selected-card-background) 100%), #fff;
    box-shadow: 0px 0px 10px 0px var(--primary-cta-translucent), 0px 0px 15px 0px var(--primary-cta-translucent);
    box-shadow: inset 0 0 0 2px var(--primary-cta); // inner border that doesn't change card size
  }

  .left-side-container {
    display: flex;
    min-width: 0;
    margin-left: -10px;
    align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};
  }

  .form-container {
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .chevron-container,
      .grabber-container {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .grabber-container {
        margin-top: -2px; // visually align with the chevron
      }

      .rotated-chevron {
        transform: rotate(-90deg);
      }

      .character-header-left-side {
        display: flex;
        min-width: 0;
        align-items: ${(props) => (props.$moveRoleSelector ? "flex-start" : "center")};

        /* No flex "gap" here — the portrait thumbnail wrapper animates its own width down to 0
           when hidden, and flex "gap" would keep reserving space around it even at 0 width. Its
           trailing margin is animated in lockstep instead (see CharacterPortraitRowThumbnail). */
        .chevron-container {
          margin-right: 8px;
        }

        /* :not(.entity-image *) keeps this from also matching the portrait placeholder icon's
           circle/path, which is nested in here too but needs its own (grey-2, unfilled path) styling. */
        svg:not(.entity-image *) {
          cursor: pointer;
          width: 24px;
          circle,
          path {
            fill: var(--grey-0);
          }
          flex-shrink: 0;

          &.chevron {
            path {
              fill: var(--grey-2);
            }
          }
        }
      }

      .character-header-right-side {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        gap: 0px;
      }

      > .item-menu {
        flex-shrink: 0;
      }

      .grabber {
        svg {
          pointer-events: none;
          width: 20px;
          height: 20px;
          circle {
            fill: var(--grey-2);
          }
        }
      }

      .chevron {
        cursor: pointer;
        width: 20px;
        height: 20px;

        path {
          fill: var(--grey-2);
        }
      }
      .role-selector {
        width: 150px;
        font-weight: 400 !important;

        svg {
          path {
            fill: var(--grey-2);
          }
        }

        .css-11pbfca-singleValue {
          & > div:first-child {
            display: block !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .dropdown {
        margin-bottom: 0px;
      }
      .title-display {
        div:not(.element-visibility-controller *, .role-selector *) {
          font-size: 18px;
          background: transparent;
          font-family: "Inter";
          font-weight: 500;
          padding: 0px;
          color: var(--grey-0);
          border: 1px solid transparent;

          &:hover {
            .ProseMirror {
              border: 1px solid var(--grey-3);
              box-shadow: var(--tiny-drop-shadow);
            }
          }
          &:focus-within {
            .ProseMirror {
              border: 1px solid var(--primary-cta);
              box-shadow: var(--tiny-drop-shadow);
            }
          }
          .ProseMirror {
            padding: 0px 6px;
            border-radius: 6px;
          }
        }

        // styles the Placeholder text via the Placeholder extension
        .ProseMirror p.is-editor-empty:first-child::before {
          color: var(--grey-1);
          content: attr(data-placeholder);
          float: left;
          height: 0;
          pointer-events: none;
        }

        margin-bottom: 0px;
      }
      .name-and-role {
        display: flex;
        min-width: 0;
        align-items: center;
        gap: 10px;
      }

      // for when the center column is at its smallest width
      &.small-width {
        align-items: flex-start;

        .name-and-role {
          flex-direction: column;
          align-items: flex-start;
        }

        .css-9p6sgq-menu {
          width: 150px;
        }
      }
    }
    .small-field-row {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      gap: 18px;
      min-height: 60px; /* Ensure minimum height for small fields */
      .field {
        width: 100%;
        min-height: 50px; /* Ensure minimum height for each field */
        input {
          width: calc(100% - 20px);
          border-radius: 5px;
          padding: 8px 8px;
          font-size: 16px;
          font-family: "Inter";
          border: 1px solid var(--grey-3);
          box-shadow: var(--tiny-drop-shadow);
          &:focus-within {
            border: 1px solid var(--primary-cta);
          }
        }
      }
    }
    .tiptap-field {
      border-radius: 5px;
      background: var(--document-background);
      padding: 0px;
      font-size: 16px;
      font-family: "Inter";
      border: 1px solid var(--grey-3);
      box-shadow: var(--tiny-drop-shadow);
      &:focus-within {
        border: 1px solid var(--primary-cta);
      }
      div {
        background: transparent;
      }
      .ProseMirror {
        color: var(--grey-0);
      }
    }
    .tiptap-fields {
      .custom-field-header {
        display: flex;
        align-items: flex-end;
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 500;
        color: var(--grey-1);

        svg {
          circle {
            fill: var(--grey-1);
          }
        }
        input {
          font-weight: 500;
          font-family: "Inter";
          padding: 0px;
          margin: 0px;
        }
      }
    }
  }
  .field {
    margin-bottom: 3px;
    .key {
      margin: 0px;
      padding: 2px 0px;
      font-size: 16px;
      font-weight: 500;
      color: var(--grey-1);
    }
  }

  .character-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .project-title {
      font-family: "Inter";
      margin-top: 9px;
      font-size: 14px;
      color: var(--grey-1);
      font-weight: 500;
    }
  }

  .error {
    background: var(--danger-color);
    color: var(--cta-text-color);
    padding: 10px;
    border-radius: 8px;
    font-size: 16px;
    font-family: "Inter";
    font-weight: 500;
  }
  .read-only.header {
    .title-display {
      margin-left: -8px;
      pointer-events: none;
    }
  }

  ${entityImageStyles}
`;

export const DotsDeleteMenuContainer = styled.div`
  a.hotdog-dots {
    display: flex;
    align-items: center;
    .icon-wrapper {
      &:hover {
        background-color: var(--menu-color-hover);
      }
    }
    svg {
      circle {
        fill: var(--grey-1);
      }
    }
  }

  .custom-field-action-menu {
    position: absolute;
    right: 14px;
    top: 39px;
    z-index: 100;

    &.visible {
      visibility: visible;
    }
    p {
      font-size: 14px;
      color: var(--grey-1);
      margin-left: 12px;
      margin-top: 18px;
    }

    .custom-field-action-menu__inner {
      background-color: var(--menu-color);
      width: 100%;
      height: 100%;
      box-shadow: var(--default-drop-shadow);
      border-radius: 14px;
      margin-top: 20px;

      .actions {
        padding: 4px;
        .delete {
          &:hover {
            background-color: var(--danger-color-hover);
          }
          &:active {
            background-color: var(--danger-color-active);
          }
        }
      }
    }

    .menu-item {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      padding: 10px 12px 10px 8px;
      border-radius: 10px !important;
      cursor: pointer;

      svg {
        path {
          fill: var(--grey-0) !important;
          stroke: none;
        }
      }

      &:hover {
        background-color: var(--menu-color-hover);
      }

      &:active {
        background-color: var(--menu-color-active);
      }

      &.selected {
        border: 2px solid var(--primary-cta) !important;
      }

      &.always {
        pointer-events: none;
        opacity: 0.5;
      }

      &.delete {
        .label {
          color: var(--danger-color);
        }
        svg {
          max-height: 24px !important;
          path {
            fill: var(--danger-color) !important;
            stroke: none;
          }
        }

        &:first-child {
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        }

        &:last-child {
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
        }
      }

      .label {
        font-size: 16px;
        // margin-left: 10px;
        white-space: nowrap;
        color: var(--grey-0);
        font-weight: 500;
      }

      .description {
        color: var(--grey-1);
        font-size: 14px;
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin-right: 5px;

        svg {
        }
      }
    }
  }

  .delete-message-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
    width: 200px;
    font-size: 16px;
    line-height: 1.3;
    color: var(--grey-0);
    font-weight: 500;
    background-color: var(--menu-color);
    border-radius: 15px;

    .delete-heading {
      font-weight: bold;
    }

    .delete-message {
      span {
        font-style: italic;
      }
    }

    .confirm {
      color: var(--danger-color);
      font-weight: 500;
      cursor: pointer;
      padding: 12px 8px;
      margin-left: -6px;
      transition: background-color 200ms;
      border-radius: 10px;
      width: fit-content;
      &:hover {
        background-color: var(--menu-color-hover);
      }
      &:active {
        background-color: var(--menu-color-active);
      }
    }
  }
`;
